import { useLazyQueryApp } from 'hooks/apolloQuery.js'

export function useLazyQuerySmart(document, variables = null, options = {}) {
  const { load, refetch, result, loading, error, onError, onResult } = useLazyQueryApp(document, variables, options)

  async function fetch(newVariables, newOptions) {
    const vars = newVariables || variables
    const opts = { ...options, ...newOptions }

    let response

    const loadResponse = await load(document, vars, opts)

    if (loadResponse !== false) {
      response = loadResponse?.data ?? loadResponse
    } else {
      const refetchResponse = await refetch(vars)
      response = refetchResponse?.data ?? refetchResponse
    }

    return response
  }

  return {
    fetch,
    result,
    loading,
    error,
    onError,
    onResult,
  }
}
